export default __webpack_public_path__ + "static/0196-6149d3bc63c71bbb3439b33805925bd9.png";